import { Environment } from '@noths/polaris-server-content-fetching';

export const getContentstackEnvironment = (isPreview?: boolean) => {
  return isPreview ? Environment.Preview : Environment.Production;
};
